import PubSub from "pubsub-js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";


import { events } from "./Events";
import { getRandomItems } from "./Utils";

export default class PickupRenderer {
  constructor() {
    this.DOM = {
      el: document.querySelector('#pickup'),
      targetEl: document.querySelector('[data-json="index-pickup"]')
    }
  }

  init() {
    if (!this.DOM.el || !this.DOM.targetEl) return;

    this.getChildren();

    this.dataFetchToken = PubSub.subscribe(events.DATA_FETCHED, (msg, data) => {
      if (data.pickup.length) this.handleFetchData(data.pickup);
    });
  }

  getChildren() {
    this.DOM.innerEl = this.DOM.el.querySelector('.pickup__inner');
  }

  handleFetchData(pickupData) {
    const randomPickupItems = getRandomItems(pickupData, 4);
    this.render(randomPickupItems);
    this.initAnim();
    PubSub.unsubscribe(this.dataFetchToken);
  }

  render(pickupData) {
    let str = ``;

    pickupData.forEach(item => {
      str += `
      <li class="pickup__item">
        <figure class="pickup__image">
          <img src="/special/groundbreakers/assets/images/${item.img}" alt="${item.title}">
        </figure>
        <div class="pickup__textbox">
          <p class="pickup__time">${item.time}</p>
          <h4 class="pickup__name">${item.title}</h4>
        </div>
      </li>`
    });

    this.DOM.targetEl.innerHTML = str;
  }

  initAnim() {
    ScrollTrigger.create({
      trigger: this.DOM.el,
      start: "top+=200 bottom",
      onEnter: () => {
        this.DOM.el.classList.add('is-anim-over');

        gsap.to(this.DOM.innerEl, {
          y: 0,
          ease: "back.out(1.75)",
          duration: 0.85,
        })
        gsap.to(this.DOM.innerEl, {
          scale: 1,
          duration: 0.85,
          ease: "expo.out"
        })
      }
    })
  }
}